import { render, staticRenderFns } from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=template&id=083d1d93&scoped=true&"
import script from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=script&lang=js&"
export * from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=script&lang=js&"
import style0 from "./MandalaEvaluationFormActionGoalItem.vue?vue&type=style&index=0&id=083d1d93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083d1d93",
  null
  
)

export default component.exports